// import { AxiosError } from 'axios';
import { NavigateFunction } from 'react-router-dom';

import { ShowMessage } from '../hooks/useMessage';
import { settingsErrorMessageConfig, defaultErrorMessage } from './messages';

const getValidationErrors = (data: any) => { // TODO: add type definition
  return data?.validationErrors;
};

const noop = () => null;

export const handleError = (
  err: any, // TODO: AxiosError or instanceof Error
  showMessage: ShowMessage = noop,
  navigate: NavigateFunction,
) => {
  let res: any = {}; // TODO: add type definition

  if (err?.response) {
    const { status, data } = err.response; // TODO: add type definitions

    if (status === 401) {
      let errorMessage = data?.error || defaultErrorMessage;
      if (!errorMessage && data?.message) {
        try {
          const parsed = JSON.parse(data.message);
          errorMessage = parsed.msg || parsed.message || data.message;
        } catch {
          errorMessage = data.message;
        }
      }
      showMessage({
        messageType: "banner",
        config: {
          tone: "critical",
          title: "Error",
          text: errorMessage,
        },
      });
      return;
    }

    if (status === 403) {
      navigate('/forbidden', { replace: true });
      return;
    }

    if (status === 500) {
      navigate('/internal-server-error', { replace: true });
      return;
    }

    if (status === 400 || status === 409) {
      const validationErrors = getValidationErrors(data);
      if (validationErrors) {
        // TODO: consider to show toast, banner or notify user in some other way that validation error has occured
        res.validationErrors = validationErrors;
      } else {
        showMessage({
          messageType: "banner",
          config: {
            tone: "critical",
            title: "Error",
            text: data?.error || defaultErrorMessage,
          },
        });
      }
    }
  } else if (err?.request) {
    showMessage(settingsErrorMessageConfig);
  } else {
    console.error(err);
    showMessage(settingsErrorMessageConfig);
  }

  return res;
};
